import { __module as arrayLikeToArray } from '../../../../_virtual/arrayLikeToArray.js';

(function (module) {
	function _arrayLikeToArray(r, a) {
	  (null == a || a > r.length) && (a = r.length);
	  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	  return n;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (arrayLikeToArray));
//# sourceMappingURL=arrayLikeToArray.js.map
